import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap, filter } from 'rxjs/operators';
import * as AuthActions from '../auth/auth.actions';
import * as TenantActions from './tenant.actions';
import { TenantService } from '../../services/tenant.service';

@Injectable()
export class TenantEffects {
  private actions$ = inject(Actions);
  private tenantService = inject(TenantService);

  loadCurrentTenantAfterAuth$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.loadUserSuccess, AuthActions.loginSuccess, AuthActions.registerSuccess),
      filter((action) => !!action.user?.tenantId),
      switchMap((action) =>
        this.tenantService.getTenantById(action.user?.tenantId ?? '').pipe(
          map((tenant) => TenantActions.loadCurrentTenantSuccess({ tenant })),
          catchError((error) =>
            of(
              TenantActions.loadCurrentTenantFailure({
                error: error?.message ?? 'Failed to load tenant',
              })
            )
          )
        )
      )
    )
  );

  /** Super admin: carica il tenant quando seleziona il contesto per la parte admin. */
  loadTenantForAdminContext$ = createEffect(() =>
    this.actions$.pipe(
      ofType(AuthActions.setAdminContextTenant),
      filter((action) => !!action.tenantId),
      switchMap((action) =>
        this.tenantService.getTenantById(action.tenantId!).pipe(
          map((tenant) => TenantActions.loadCurrentTenantSuccess({ tenant })),
          catchError((error) =>
            of(
              TenantActions.loadCurrentTenantFailure({
                error: error?.message ?? 'Failed to load tenant',
              })
            )
          )
        )
      )
    )
  );
}
